import { Component, input, Input, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SourceEnum } from '../../../../shared/store/typeahead/types';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContractService } from '../../../../shared/store/contract/contract.service';
import { SubHeaderService } from '../../../../shared/store/subheader/subheader.service';
import { FormService } from '../../../../shared/store/form/form.service';
import { ContractStatusHistoryModel } from '../../../../shared/store/contract/types';
import { take } from 'rxjs/operators';
import { filterTrue } from '../../../../shared/pipe/rxjs/operators';
import { ModalService } from '../../../../shared/service/modal.service';
import { GenericApiCall } from '../../../../common/store/types';
import { filter, Observable } from 'rxjs';
import { formatDate } from '../../../../shared/helper/datehelper';
import { TimeZoneService } from '../../../../common/time-zone/time-zone.service';
import {
  ModalComponent,
  ModalComponentKey,
} from 'src/app/shared/service/modal-component';

@UntilDestroy()
@ModalComponent(ModalComponentKey.ContractStatusHistoryEdit)
@Component({
  selector: 'app-contract-status-history-edit-content',
  standalone: false,
  templateUrl: './contract-status-history-edit-content.component.html',
  styleUrl: './contract-status-history-edit-content.component.scss',
})
export class ContractStatusHistoryEditContentComponent
  implements OnInit, OnDestroy
{
  readonly modalRandomIdentifier = input.required<number>();
  readonly contractStatusHistoryId = input.required<number>();
  readonly contractId = input.required<number>();
  readonly source = input<SourceEnum>(SourceEnum.Component);

  contractStatusHistoryModel$: Observable<ContractStatusHistoryModel>;

  form: FormGroup;
  apiCall: GenericApiCall<any, any>;

  fromStatus: string = '';
  toStatus: string = '';

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly contractService: ContractService,
    private readonly subHeaderService: SubHeaderService,
    private readonly formService: FormService,
    private readonly dynamicService: ModalService,
    private readonly timeZoneService: TimeZoneService,
  ) {
    this.contractStatusHistoryModel$ =
      this.contractService.getContractStatusHistory.value$;
  }

  ngOnInit(): void {
    this.apiCall = this.contractService.getContractStatusHistory;
    this.contractService.getContractStatusHistory.call({
      contractId: this.contractId(),
      contractStatusHistoryId: this.contractStatusHistoryId(),
    });

    this.form = this.formBuilder.group({
      changeDate: [undefined, Validators.required],
      fromStatus: [undefined],
      fromStatusLoc: [''],
      toStatus: [undefined, Validators.required],
      toStatusLoc: ['', Validators.required],
    });

    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'contractStatusHistoryUpdate') this.onSubmit();

        this.subHeaderService.setTriggerAction('');
      });

    this.contractStatusHistoryModel$
      .pipe(
        filter((x) => !!x),
        take(1),
      )
      .subscribe((x) => {
        this.form.patchValue({
          changeDate: this.timeZoneService.fromUtcToLocal(
            x.changeDate,
            "yyyy-MM-dd'T'HH:mm",
          ),
          fromStatus: x.fromStatus,
          fromStatusLoc: x.fromStatusLoc,
          toStatus: x.toStatus,
          toStatusLoc: x.toStatusLoc,
        });
      });
  }

  onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.formService.countErrors(this.form, true);
      return;
    }
    const changeDate = this.timeZoneService.fromLocalToUtc(
      this.form.get('changeDate')?.value,
      false,
    );

    const contractStatusHistoryModel: ContractStatusHistoryModel = {
      id: this.contractStatusHistoryId(),
      contractId: this.contractId(),
      changeDate: changeDate!,
      fromStatus: this.form.get('fromStatus')?.value,
      toStatus: this.form.get('toStatus')?.value,

      fromStatusLoc: '',
      toStatusLoc: '',
    };

    const result$ = this.contractService.updateContractStatusHistory.call(
      contractStatusHistoryModel,
    );

    result$.pipe(filterTrue(), take(1)).subscribe((result) => {
      this.formService.clear();
      switch (this.source()) {
        case SourceEnum.Component:
          // if (result.id == user.contactId) {
          //   this.userService.getCurrentUser.call();
          // }
          // this.router.navigate(['/Contacts/Contacts/Details', result.id]);
          break;
        case SourceEnum.Modal:
          this.dynamicService.outputFromDynamicComponent(
            this.modalRandomIdentifier(),
            result.id.toString(),
          );
          break;
        default:
          // this.router.navigate(['/Contacts/Contacts/Details', result.id]);
          break;
      }
    });
  }

  ngOnDestroy(): void {
    this.contractService.updateContractStatusHistory.reset();
    this.contractService.getContractStatusHistory.reset();
  }
}
